<template>
  <div class="accordion-item border-0 pb-4">
    <h2 class="accordion-header">
      <button
        class="accordion-button rounded-3 fw-bold py-2 ps-3 pe-3"
        :class="closed ? 'collapsed' : ''"
        type="button"
        data-bs-toggle="collapse"
        :data-bs-target="`#${id}`"
        :aria-expanded="closed ? 'false' : 'true'"
        :aria-controls="id"
        style="background-color: #f1f1f1; color: black"
      >
        {{ title }} &nbsp;<span>(</span>{{ total }}<span>)</span>
      </button>
    </h2>
    <div
      :id="id"
      class="accordion-collapse collapse"
      :class="[closed ? '' : 'show']"
      data-bs-parent="#things"
      aria-expanded="false"
    >
      <div class="accordion-body px-0">
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import utils from "@/libraries/utils/utils";

export default {
  name: "AccordianComp",
  data() {
    return {
      id: null,
    };
  },
  props: {
    title: {
      type: String,
      required: false,
      default: "New",
    },
    total: {
      type: String,
      required: false,
    },
    closed: {
      type: Boolean,
      required: false,
    },
  },
  mounted() {
    this.id = utils.randomString(32);
  },
};
</script>

<style scoped></style>
